import { AssetInfoDto, CustomerCommissionDto } from 'common/api/autogenerated/trading-gateway';

import { AssetsHashMap, CoinGroupsHashMap, GroupsHashMap } from 'common/types';

export const initialState: {
  assets: AssetsHashMap;
  coins: AssetsHashMap;
  favoritesAssets: string[];
  favoritesCoins: string[];
  groupsAssets: GroupsHashMap;
  groupsCoins: CoinGroupsHashMap;
  connected: boolean;
  connections: {
    [key: string]: boolean;
  };
  info: AssetInfoDto & { symbol: string | null };
  commissions: CustomerCommissionDto;
  loading: boolean;
  assetsLoading: boolean;
  coinsLoading: boolean;
  assetInfoLoading: boolean;
  assetsGroupsLoading: boolean;
  assetsFavoritesLoading: boolean;
  coinsFavoritesLoading: boolean;
  coinsGroupsLoading: boolean;
  initialLoad: boolean;
} = {
  assets: {},
  coins: {},
  favoritesAssets: [],
  favoritesCoins: [],
  groupsAssets: {},
  groupsCoins: {},
  connected: false,
  connections: {},
  info: {
    symbol: null,
    sentiment: {
      buy: 0,
      sell: 0,
    },
  },
  commissions: {
    takerCommission: 0,
    makerCommission: 0,
  },
  loading: true,
  assetsLoading: true,
  assetInfoLoading: true,
  assetsGroupsLoading: true,
  assetsFavoritesLoading: true,
  initialLoad: true,
  coinsLoading: true,
  coinsGroupsLoading: false,
  coinsFavoritesLoading: false,
};
